import { Link } from 'react-router-dom'

/**
 * Chat oder Karte — zwei gleichrangige Ansichten derselben Reise.
 *
 * Ein Umschalter und keine dritte Ebene: beides ist der Bericht, nur anders
 * erzählt. Die Reiseseite (`/info`) steht daneben und bleibt, wo sie ist —
 * sie ist Verwaltung und keine Ansicht.
 *
 * Unter der Kopfzeile statt darin: auf einem Telefon ist der Kopf schon voll,
 * und ein Umschalter, der sich zwischen Titel und Zurück-Pfeil quetscht, wird
 * mit dem Daumen nicht getroffen.
 */
export function Reiseumschalter({
  tripId,
  aktiv,
}: {
  tripId: number
  aktiv: 'chat' | 'karte'
}) {
  return (
    <nav className="umschalter" aria-label="Ansicht">
      <Link
        className={aktiv === 'chat' ? 'umschalter__feld umschalter__feld--aktiv' : 'umschalter__feld'}
        to={`/t/${tripId}`}
        aria-current={aktiv === 'chat' ? 'page' : undefined}
      >
        Chat
      </Link>
      <Link
        className={aktiv === 'karte' ? 'umschalter__feld umschalter__feld--aktiv' : 'umschalter__feld'}
        to={`/t/${tripId}/karte`}
        aria-current={aktiv === 'karte' ? 'page' : undefined}
      >
        Karte
      </Link>
    </nav>
  )
}
